$('.resourceID').on('click', function () {
    $("#fileID").val($(this).attr('resource-id'));
})